(function(){
  'use strict';
  document.querySelectorAll('[data-skin-collection]').forEach(function(root){
    var cards=Array.from(root.querySelectorAll('[data-skin-card]'));
    var filters=Array.from(root.querySelectorAll('[data-skin-filter]'));
    filters.forEach(function(button){button.addEventListener('click',function(){
      var chosen=button.dataset.skinFilter,count=0;
      cards.forEach(function(card){var show=!chosen||card.dataset.routine===chosen;card.hidden=!show;if(show)count++;});
      filters.forEach(function(item){item.setAttribute('aria-pressed',String(item===button));});
      root.querySelector('[data-skin-count]').textContent=count+' '+(count===1?'product':'products')+(chosen?' · '+chosen:'');
    });});
  });
  document.querySelectorAll('[data-skin-duo-form]').forEach(function(form){
    if(form.dataset.ready)return;form.dataset.ready='true';
    form.addEventListener('submit',async function(event){
      event.preventDefault();
      var button=form.querySelector('button'),status=form.querySelector('[data-skin-duo-status]');
      if(button.disabled)return;button.disabled=true;button.textContent='Adding both products…';status.hidden=true;
      var inputs=new FormData(form);
      var items=[0,1].map(function(index){return{id:Number(inputs.get('items['+index+'][id]')),quantity:1};});
      try{
        var response=await fetch(form.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:items})});
        var result=await response.json();
        if(!response.ok)throw new Error(result.description||'Please check availability on each product page.');
        window.location.assign(form.dataset.cartUrl);
      }catch(error){
        status.textContent='We could not confirm both items were added. Please review your cart before trying again. '+(error.message||'');status.hidden=false;
        var link=document.createElement('a');link.href=form.dataset.cartUrl;link.textContent=' Review cart →';status.appendChild(link);
        button.disabled=false;button.textContent='Add both products to cart';
      }
    });
  });
}());
